import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import type { StepperProps } from '@mui/material';
import { Step, StepButton, Stepper } from '@mui/material';

import {
  BulkEditContext,
  BulkEditStep,
} from 'src/components/userAdmin/UserBulkEditDialog/components/BulkEditDialog';

import { styles } from './index.styles';

export interface BulkEditStepperProps extends StepperProps {}

/**
 * Renders the bulk edit stepper.
 */
const BulkEditStepper: FC<BulkEditStepperProps> = ({ sx = [], ...props }) => {
  const { t } = useTranslation('admin');
  const { setBulkEditingStep, bulkEditingStep } = useContext(BulkEditContext);

  const steps = [
    {
      label: t('BulkEdit.StepSelectType'),
      onClick: () => setBulkEditingStep(BulkEditStep.ChangeAttributes),
      value: BulkEditStep.SelectType,
    },
    {
      label: t('BulkEdit.StepChangeAttributes'),
      onClick: () => setBulkEditingStep(BulkEditStep.ConfirmChanges),
      value: BulkEditStep.ChangeAttributes,
    },
    {
      label: t('BulkEdit.StepConfirm'),
      onClick: () => setBulkEditingStep(BulkEditStep.SelectType),
      value: BulkEditStep.ConfirmChanges,
    },
  ];

  return (
    <Stepper
      className="BulkEditStepper-root"
      sx={[styles.bulkEditStepper, ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
      nonLinear
    >
      {steps.map((step) => (
        <Step
          active={bulkEditingStep === step.value}
          completed={bulkEditingStep > step.value}
          disabled={bulkEditingStep <= step.value}
          key={step.label}
        >
          <StepButton onClick={() => setBulkEditingStep(step.value)}>
            {step.label}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default BulkEditStepper;
